import Loading from 'components/Loading';
import Page404 from 'pages/Error';
import HI88Page from 'pages/Home';
import PrizeStructure from 'pages/Home/prizeStructure';
import RuleFixPage from 'pages/Home/rule_fix';
import { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import favicon from './assets/images/favicon.ico';
import { SITE } from './config/config';

const favicons = {
  ok9: favicon
};

function Apps() {
  useEffect(() => {
    const faviconElement =
      document.querySelector("link[rel*='icon']") || document.createElement('link');
    faviconElement.type = 'image/png';
    faviconElement.rel = 'icon';
    faviconElement.href = favicons[SITE];
  }, []);

  return (
    <RecoilRoot>
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route exact path="/" element={<HI88Page />} />
            <Route path="/rule" element={<RuleFixPage />} />
            <Route path="/prize-structure" element={<PrizeStructure />} />
            {/* Add other routes here */}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default Apps;
